import { DatePicker } from "@mui/x-date-pickers";
import { useMemo } from "react";
import { makeStyles } from "tss-react/mui";
import moment from "moment";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { jsx as _jsx } from "react/jsx-runtime";
export function TDatePickerProvider(props) { return /*#__PURE__*/ _jsx(LocalizationProvider, { dateAdapter: AdapterMoment, children: props.children }); }
var useStyles = makeStyles()(function (theme) { return ({ paddingBottom: { marginBottom: theme.spacing(2) } }); });
export function TDatePicker(props) { var styles = useStyles().classes; var value = useMemo(function () { return moment(props.value); }, [props.value]); return /*#__PURE__*/ _jsx(DatePicker, { className: styles.paddingBottom, label: props.label, format: "YYYY-MM-DD", value: value, onChange: function (value) { if (!value) {
        props.onChange(null);
        return;
    } var date = moment(value.toDate()).startOf("date"); props.onChange(date.toDate()); } }); }
